export default __webpack_public_path__ + "static/media/scripts-disabled-01.b7b871f5.png";